import axios from "@/axios";

export const namespaced = true

export const state = {
    user: {},
    users: []
}

export const getters = {
    users: (state) => state.users,
    user: state => state.user
}

export const mutations = {
    SET_USERS: (state, resp) => (state.users = resp.data),
    SET_USER: (state, resp) => (state.user = resp.data)
}

export const actions = {
    async getUsers({ commit }) {
        commit('SET_USERS', await axios.get("/api/applicationusers"))
    },
    //async getEditableUsers({ commit }) {
    //    commit('SET_USERS', await axios.get("/api/applicationusers/allusers"))
    //},
    async getUser({ state, commit }, id) {
        commit('SET_USER', await axios.get("/api/applicationusers/id/" + id))
    },

    saveUser({ commit, state }) {
        return axios.post("/api/applicationusers/", state.user)
            .then(({ data }) => {
                commit("SET_USER", state.user)
            })
    },
}
